import {CloseButton, Drawer, Loader, Tabs, Text} from "@mantine/core";
import IconX from "../../../assets/x.svg?react";
import {usePanel} from "./PanelContext";
import {PanelContent} from "./PanelContent";
import classes from "./SliderPanel.module.css";

export const SliderPanel = () => {
    const {items, activeKey, isOpen, closeAll, closePanel, setActivePanel} =
        usePanel();

    return (
        <Drawer
            opened={isOpen}
            onClose={closeAll}
            position="right"
            size="lg"
            trapFocus={false}
            lockScroll={false}
            withOverlay={false}
            withCloseButton={false}
            transitionProps={{exitDuration: 0}}
        >
            <div className={classes.header}>
                <Text fw={600} size="lg">
                    Panel
                </Text>
                <CloseButton onClick={closeAll} />
            </div>

            <Tabs
                value={activeKey}
                onChange={(val) => val && setActivePanel(val)}
            >
                <Tabs.List>
                    {items.map((item) => (
                        <Tabs.Tab key={item.key} value={item.key}>
                            {item.label}
                            <span
                                role="button"
                                tabIndex={0}
                                className={classes.tabCloseButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closePanel(item.key);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.stopPropagation();
                                        closePanel(item.key);
                                    }
                                }}
                                aria-label="Close tab"
                            >
                                <IconX width={12} height={12} />
                            </span>
                        </Tabs.Tab>
                    ))}
                </Tabs.List>

                {items.map((item) => (
                    <Tabs.Panel key={item.key} value={item.key} pt="sm">
                        {item.status === "loading" && (
                            <>
                                <Loader size="sm" /> Loading...
                            </>
                        )}
                        {item.status === "loaded" && (
                            <PanelContent item={item} />
                        )}
                        {item.status === "error" && (
                            <Text c="red">{item.error || "Error"}</Text>
                        )}
                    </Tabs.Panel>
                ))}
            </Tabs>
        </Drawer>
    );
};
